export default __webpack_public_path__ + "static/media/Brow_2_C4.33d679c4.svg";